.text {
  color: var(--vapor-text-color, inherit);
  display: block;
}

.highlight {
  background-color: var(--colors-background-interactive-highlight);
  color: inherit;
}

/* Display overrides */
.text:where([data-display='inline']) {
  display: inline;
}

.text:where([data-display='inline-block']) {
  display: inline-block;
}

/* Text align */
.text:where([data-text-align='left']) {
  text-align: left;
}

.text:where([data-text-align='center']) {
  text-align: center;
}

.text:where([data-text-align='right']) {
  text-align: right;
}

/* Italic */
.text:where([data-italic]) {
  font-style: italic;
}

/* Variant numeric */
.text:where([data-variant-numeric='tabular-nums']) {
  font-variant-numeric: tabular-nums;
}

/* Font weight override — bare selector (no :where()) to win over variant class */
.text[data-font-weight] {
  font-weight: var(--vapor-text-font-weight);
}

/* Single-line truncation */
.text:where([data-truncate='single']) {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  /* Safari hack: suppress native truncation tooltip */
  &::after {
    content: '';
    display: block;
  }
}

/* Middle truncation */
.text:where([data-truncate='middle']) {
  display: flex;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Multi-line truncation */
.text:where([data-truncate='multi']) {
  -webkit-box-orient: vertical;
  line-clamp: var(--vapor-text-line-clamp);
  -webkit-line-clamp: var(--vapor-text-line-clamp);
  display: -webkit-box;
  overflow: hidden;
  overflow-wrap: break-word;
}

/* Sub-elements for middle truncation */
.truncatedSpan {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre;
}

.truncatedSpanRemaining {
  white-space: pre;
}
